import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../../features/collections/redux/actions';
import ParentDocCard from '../../common/ParentDocCard';
import ParentContentCard from '../../common/ParentContentCard';
import CollectionHeaderNav from './../CollectionHeaderNav';
import CustomLoader from '../../common/CustomLoader';
import types from '../../../common/formElements/CollectionSectionType';
import IndexList from './IndexList';
import CreateIndex from './CreateIndex';
import { filterIndexFields } from 'drapcode-constant';
import ParentCardNoCol from '../../common/ParentCardNoCol';

export class CollectionIndex extends Component {
  static propTypes = {
    collections: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  componentDidMount() {
    const { projectId, collectionId, version } = this.props.match.params;
    this.props.actions.loadProjectCollectionDetail({ projectId, collectionId, version });
  }

  showCollectionIndex = () => {
    const { collections, actions } = this.props;
    const { selectedCollection } = collections;
    if (selectedCollection) {
      const fields = filterIndexFields(selectedCollection.fields);
      if (!fields || fields.length === 0) {
        return (
          <ParentContentCard title="Create Index" icon="indexing">
            No Fields are available for Indexing
          </ParentContentCard>
        );
      }
      return (
        <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 drapcode">
          <ParentCardNoCol title="Create Index" icon="indexing">
            <CreateIndex fields={fields} actions={actions} />
          </ParentCardNoCol>
          <ParentCardNoCol title="Collection's Indexes" icon="list">
            <IndexList indexes={selectedCollection.indexes} />
          </ParentCardNoCol>
        </div>
      );
    } else {
      return '';
    }
  };

  render() {
    const { collections, match, actions } = this.props;
    const { projectId, collectionId, version } = match.params;
    const { loadProjectCollectionDetailPending, selectedCollection } = collections;
    return (
      <div className="main">
        <div className="section">
          <div className="container">
            <CollectionHeaderNav
              label={types.INDEXING}
              projectId={projectId}
              version={version}
              selectedCollection={selectedCollection}
              loadProjectCollectionDetailPending={loadProjectCollectionDetailPending}
            />
            {loadProjectCollectionDetailPending && (
              <div className="text-center">
                <CustomLoader
                  loading={loadProjectCollectionDetailPending}
                  size="20px"
                  color="#303453"
                />
              </div>
            )}

            <div className="row mx-auto">
              {this.showCollectionIndex()}
              <ParentDocCard>
                <h5>About Collection Data </h5>
              </ParentDocCard>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    collections: state.collections,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(CollectionIndex);
